module.exports = __webpack_public_path__ + "static/dragon_scale_mail-0d47c98aa0b953061d3b38e223a4f0ef.jpeg";